const hasCoords = (value) => Array.isArray(value) && value.length > 0;

// Effective location of a monitoring site.
// Precedence: confirmed on-the-ground point -> relocated-but-unconfirmed target ->
// immutable planning anchor. `plannedLocation` is the anchor both field randomizers
// draw relative to, so a relocation only ever writes `backupLocation`; overwriting
// the anchor would make every past draw irreproducible.
export function siteNavLocation(site) {
  if (!site) return null;
  if (hasCoords(site.actualLocation)) return site.actualLocation;
  if (hasCoords(site.backupLocation)) return site.backupLocation;
  if (hasCoords(site.plannedLocation)) return site.plannedLocation;
  return null;
}
